import { render, staticRenderFns } from "./DynamicallyPaginated.vue?vue&type=template&id=634fe829&"
import script from "./DynamicallyPaginated.vue?vue&type=script&lang=js&"
export * from "./DynamicallyPaginated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
